"use client";

import ErrorPage from "@/components/ErrorPage";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Determine if this is a permission error
  const isPermissionError =
    error.message === "Permission denied" || error.digest === "3015786222";

  const isDev = process.env.NODE_ENV === "development";

  return (
    <ErrorPage
      error={error}
      reset={reset}
      message={
        !isPermissionError
          ? "Our system is currently being updated to enhance your experience."
          : ""
      }
      isPermissionError={isPermissionError}
      title={
        isPermissionError
          ? "You don’t have access to view this page"
          : "We'll be back soon"
      }
      showErrorDetails={isDev}
    />
  );
}
